/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * Search API
 * API for search suggestions, menu, and history
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * Retrieve search menu containing all categories, popular brands, and popular products
 * @summary Get search menu data
 */
export const getSearchMenu200ResponseDataParentCategoriesItemOneCategoryNameMax = 100;

export const getSearchMenu200ResponseDataParentCategoriesItemOneCategoryIconMax = 40;

export const getSearchMenu200ResponseDataParentCategoriesItemOneProductsCountMin = 0;

export const getSearchMenu200ResponseDataParentCategoriesItemTwoCategoriesItemCategoryNameMax = 100;

export const getSearchMenu200ResponseDataParentCategoriesItemTwoCategoriesItemCategoryIconMax = 40;

export const getSearchMenu200ResponseDataParentCategoriesItemTwoCategoriesItemProductsCountMin = 0;

export const getSearchMenu200ResponseDataCategoriesItemCategoryNameMax = 100;

export const getSearchMenu200ResponseDataCategoriesItemCategoryIconMax = 40;

export const getSearchMenu200ResponseDataCategoriesItemProductsCountMin = 0;

export const getSearchMenu200ResponseDataPopularBrandsItemItemNameMax = 100;

export const getSearchMenu200ResponseDataAllBrandsItemBrandNameMax = 100;

export const getSearchMenu200ResponseDataAllBrandsItemProductsCountMin = 0;

export const getSearchMenu200ResponseDataAllBrandsItemBrandIndexMax = 5;

export const getSearchMenu200ResponseDataAllBrandsItemCountryMax = 100;

export const getSearchMenu200ResponseDataAllBrandsItemWebsiteMax = 1024;

export const getSearchMenu200ResponseDataAllBrandsItemFacebookMax = 1024;

export const getSearchMenu200ResponseDataAllBrandsItemInstagramMax = 255;

export const getSearchMenu200ResponseDataAllBrandsItemYoutubeMax = 1024;

export const getSearchMenu200ResponseDataAllBrandsItemTiktokMax = 1024;

export const getSearchMenu200ResponseDataAllBrandsItemXMax = 1024;

export const getSearchMenu200ResponseDataPopularProductsItemItemNameMax = 100;

export const getSearchMenu200ResponseDataPopularKeywordsItemItemNameMax = 100;

export const GetSearchMenu200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                parent_categories: zod
                    .array(
                        zod
                            .object({
                                category_id: zod.number().nullable().describe("Category ID"),
                                category_name: zod
                                    .string()
                                    .max(getSearchMenu200ResponseDataParentCategoriesItemOneCategoryNameMax)
                                    .describe("Category name"),
                                category_icon: zod
                                    .string()
                                    .max(getSearchMenu200ResponseDataParentCategoriesItemOneCategoryIconMax)
                                    .optional()
                                    .describe(
                                        "SVG sprite symbol id for the category icon (e.g. vlf-cat-105). Empty when unset.",
                                    ),
                                parent_category_id: zod
                                    .number()
                                    .nullish()
                                    .describe("Parent category ID (null for parent categories)"),
                                display_order: zod.number().optional().describe("Display order"),
                                review_config_id: zod.number().optional().describe("Review config ID"),
                                products_count: zod
                                    .number()
                                    .min(getSearchMenu200ResponseDataParentCategoriesItemOneProductsCountMin)
                                    .optional()
                                    .describe("Number of active products in this category (derived)"),
                                is_active: zod.number().optional().describe("Active flag"),
                                created_at: zod
                                    .string()
                                    .datetime({ offset: true })
                                    .optional()
                                    .describe("Creation timestamp"),
                                updated_at: zod
                                    .string()
                                    .datetime({ offset: true })
                                    .optional()
                                    .describe("Update timestamp"),
                                categories: zod
                                    .array(
                                        zod
                                            .object({
                                                category_id: zod.number().nullable().describe("Category ID"),
                                                category_name: zod
                                                    .string()
                                                    .max(
                                                        getSearchMenu200ResponseDataParentCategoriesItemTwoCategoriesItemCategoryNameMax,
                                                    )
                                                    .describe("Category name"),
                                                category_icon: zod
                                                    .string()
                                                    .max(
                                                        getSearchMenu200ResponseDataParentCategoriesItemTwoCategoriesItemCategoryIconMax,
                                                    )
                                                    .optional()
                                                    .describe(
                                                        "SVG sprite symbol id for the category icon (e.g. vlf-cat-105). Empty when unset.",
                                                    ),
                                                parent_category_id: zod
                                                    .number()
                                                    .nullish()
                                                    .describe("Parent category ID (null for parent categories)"),
                                                display_order: zod.number().optional().describe("Display order"),
                                                review_config_id: zod.number().optional().describe("Review config ID"),
                                                products_count: zod
                                                    .number()
                                                    .min(
                                                        getSearchMenu200ResponseDataParentCategoriesItemTwoCategoriesItemProductsCountMin,
                                                    )
                                                    .optional()
                                                    .describe("Number of active products in this category (derived)"),
                                                is_active: zod.number().optional().describe("Active flag"),
                                                created_at: zod
                                                    .string()
                                                    .datetime({ offset: true })
                                                    .optional()
                                                    .describe("Creation timestamp"),
                                                updated_at: zod
                                                    .string()
                                                    .datetime({ offset: true })
                                                    .optional()
                                                    .describe("Update timestamp"),
                                            })
                                            .strict(),
                                    )
                                    .describe("Child categories under this parent"),
                            })
                            .strict(),
                    )
                    .optional()
                    .describe("Categories grouped as Parent > Child (preferred for UI)"),
                categories: zod
                    .array(
                        zod
                            .object({
                                category_id: zod.number().nullable().describe("Category ID"),
                                category_name: zod
                                    .string()
                                    .max(getSearchMenu200ResponseDataCategoriesItemCategoryNameMax)
                                    .describe("Category name"),
                                category_icon: zod
                                    .string()
                                    .max(getSearchMenu200ResponseDataCategoriesItemCategoryIconMax)
                                    .optional()
                                    .describe(
                                        "SVG sprite symbol id for the category icon (e.g. vlf-cat-105). Empty when unset.",
                                    ),
                                parent_category_id: zod
                                    .number()
                                    .nullish()
                                    .describe("Parent category ID (null for parent categories)"),
                                display_order: zod.number().optional().describe("Display order"),
                                review_config_id: zod.number().optional().describe("Review config ID"),
                                products_count: zod
                                    .number()
                                    .min(getSearchMenu200ResponseDataCategoriesItemProductsCountMin)
                                    .optional()
                                    .describe("Number of active products in this category (derived)"),
                                is_active: zod.number().optional().describe("Active flag"),
                                created_at: zod
                                    .string()
                                    .datetime({ offset: true })
                                    .optional()
                                    .describe("Creation timestamp"),
                                updated_at: zod
                                    .string()
                                    .datetime({ offset: true })
                                    .optional()
                                    .describe("Update timestamp"),
                            })
                            .strict(),
                    )
                    .optional()
                    .describe("All categories (legacy flat list; kept for compatibility)"),
                popular_brands: zod
                    .array(
                        zod
                            .object({
                                item_id: zod
                                    .union([zod.number(), zod.string()])
                                    .describe("Item ID (brand ID or product ID)"),
                                type: zod
                                    .enum(["category", "brand", "product", "keyword", "post_title", "user", "hashtag"])
                                    .describe("Search type"),
                                item_name: zod
                                    .string()
                                    .max(getSearchMenu200ResponseDataPopularBrandsItemItemNameMax)
                                    .describe("Item name"),
                                search_count: zod.number().describe("Number of times searched"),
                                image_url: zod.string().optional().describe("Item image URL (optional)"),
                            })
                            .strict(),
                    )
                    .optional()
                    .describe("Top 10 popular brands by search count"),
                all_brands: zod
                    .array(
                        zod
                            .object({
                                brand_id: zod.number().nullable().describe("Brand ID"),
                                brand_name: zod
                                    .string()
                                    .max(getSearchMenu200ResponseDataAllBrandsItemBrandNameMax)
                                    .describe("Brand name"),
                                products_count: zod
                                    .number()
                                    .min(getSearchMenu200ResponseDataAllBrandsItemProductsCountMin)
                                    .optional()
                                    .describe("Number of products for this brand (0 when none)"),
                                products_count_guest: zod
                                    .number()
                                    .nullish()
                                    .describe("Guest-facing products_count when present"),
                                image_url: zod.string().optional().describe("Brand image URL (optional)"),
                                brand_index: zod
                                    .string()
                                    .max(getSearchMenu200ResponseDataAllBrandsItemBrandIndexMax)
                                    .optional()
                                    .describe("Brand sort index when present"),
                                brand_status: zod
                                    .enum(["draft", "editing", "released", "duplicated", "rejected"])
                                    .optional()
                                    .describe("Canonical brand status when present"),
                                brand_description_th: zod
                                    .string()
                                    .optional()
                                    .describe("Thai brand description when present"),
                                brand_description_en: zod
                                    .string()
                                    .optional()
                                    .describe("English brand description when present"),
                                brand_description_ja: zod
                                    .string()
                                    .optional()
                                    .describe("Japanese brand description when present"),
                                review_count: zod.number().nullish().describe("Brand review count when present"),
                                review_count_guest: zod
                                    .number()
                                    .nullish()
                                    .describe("Guest-facing review_count when present"),
                                posts_count_guest: zod
                                    .number()
                                    .nullish()
                                    .describe(
                                        "Guest-facing posts_count when present (posts_count itself is excluded from this endpoint's response — see SearchMenuService's exclude_fields)",
                                    ),
                                average_rating: zod.number().nullish().describe("Brand average rating when present"),
                                activate_time: zod
                                    .string()
                                    .datetime({ offset: true })
                                    .nullish()
                                    .describe("Brand activation timestamp when present"),
                                priority: zod
                                    .union([
                                        zod.literal(1),
                                        zod.literal(2),
                                        zod.literal(3),
                                        zod.literal(4),
                                        zod.literal(5),
                                        zod.literal(9),
                                    ])
                                    .optional()
                                    .describe("Brand priority when present"),
                                country: zod
                                    .string()
                                    .max(getSearchMenu200ResponseDataAllBrandsItemCountryMax)
                                    .optional()
                                    .describe("Brand country when present"),
                                website: zod
                                    .string()
                                    .max(getSearchMenu200ResponseDataAllBrandsItemWebsiteMax)
                                    .optional()
                                    .describe("Brand website when present"),
                                facebook: zod
                                    .string()
                                    .max(getSearchMenu200ResponseDataAllBrandsItemFacebookMax)
                                    .optional()
                                    .describe("Brand Facebook URL when present"),
                                instagram: zod
                                    .string()
                                    .max(getSearchMenu200ResponseDataAllBrandsItemInstagramMax)
                                    .optional()
                                    .describe("Brand Instagram URL when present"),
                                youtube: zod
                                    .string()
                                    .max(getSearchMenu200ResponseDataAllBrandsItemYoutubeMax)
                                    .optional()
                                    .describe("Brand YouTube URL when present"),
                                tiktok: zod
                                    .string()
                                    .max(getSearchMenu200ResponseDataAllBrandsItemTiktokMax)
                                    .optional()
                                    .describe("Brand TikTok URL when present"),
                                x: zod
                                    .string()
                                    .max(getSearchMenu200ResponseDataAllBrandsItemXMax)
                                    .optional()
                                    .describe("X profile URL or username (null if not available)"),
                                brand_video_post_ids: zod
                                    .array(zod.number())
                                    .nullish()
                                    .describe(
                                        "Post IDs with video\/SNS media linked to this brand (batch-updated pool)",
                                    ),
                                created_by: zod.number().nullish().describe("Brand creator user ID when present"),
                                updated_by: zod.number().nullish().describe("Brand updater user ID when present"),
                                created_at: zod
                                    .string()
                                    .datetime({ offset: true })
                                    .optional()
                                    .describe("Brand creation timestamp when present"),
                                updated_at: zod
                                    .string()
                                    .datetime({ offset: true })
                                    .optional()
                                    .describe("Brand update timestamp when present"),
                            })
                            .strict()
                            .describe("Minimal brand representation for pickers"),
                    )
                    .optional()
                    .describe("All brands for brand picker modal (used for filtering \/ full list)"),
                popular_products: zod
                    .array(
                        zod
                            .object({
                                item_id: zod
                                    .union([zod.number(), zod.string()])
                                    .describe("Item ID (brand ID or product ID)"),
                                type: zod
                                    .enum(["category", "brand", "product", "keyword", "post_title", "user", "hashtag"])
                                    .describe("Search type"),
                                item_name: zod
                                    .string()
                                    .max(getSearchMenu200ResponseDataPopularProductsItemItemNameMax)
                                    .describe("Item name"),
                                search_count: zod.number().describe("Number of times searched"),
                                image_url: zod.string().optional().describe("Item image URL (optional)"),
                            })
                            .strict(),
                    )
                    .optional()
                    .describe("Top 10 popular products by search count"),
                popular_keywords: zod
                    .array(
                        zod
                            .object({
                                item_id: zod
                                    .union([zod.number(), zod.string()])
                                    .describe("Item ID (brand ID or product ID)"),
                                type: zod
                                    .enum(["category", "brand", "product", "keyword", "post_title", "user", "hashtag"])
                                    .describe("Search type"),
                                item_name: zod
                                    .string()
                                    .max(getSearchMenu200ResponseDataPopularKeywordsItemItemNameMax)
                                    .describe("Item name"),
                                search_count: zod.number().describe("Number of times searched"),
                                image_url: zod.string().optional().describe("Item image URL (optional)"),
                            })
                            .strict(),
                    )
                    .optional()
                    .describe("Top 10 popular keywords by search count"),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GetSearchMenu400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
    })
    .strict();

export const GetSearchMenu500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
    })
    .strict();

/**
 * Retrieve search suggestions based on query input
 * @summary Get search suggestions
 */
export const getSearchSuggestionsQueryQueryMax = 100;

export const getSearchSuggestionsQueryLimitDefault = 10;
export const getSearchSuggestionsQueryLimitMax = 50;

export const GetSearchSuggestionsQueryParams = zod
    .object({
        query: zod.string().min(1).max(getSearchSuggestionsQueryQueryMax).describe("Search query string"),
        section_id: zod
            .enum(["tech", "programming", "products", "frontend", "devops", "general"])
            .optional()
            .describe("Filter by section ID"),
        search_type: zod
            .enum(["category", "brand", "product", "keyword", "post_title", "user", "hashtag"])
            .optional()
            .describe("Filter by suggestion type"),
        limit: zod
            .number()
            .min(1)
            .max(getSearchSuggestionsQueryLimitMax)
            .default(getSearchSuggestionsQueryLimitDefault)
            .describe("Maximum number of suggestions to return"),
    })
    .strict();

export const getSearchSuggestions200ResponseDataSuggestionsItemValueMax = 100;

export const getSearchSuggestions200ResponseDataSuggestionsItemTextMax = 100;

export const getSearchSuggestions200ResponseDataSuggestionsItemOutputFieldMax = 100;

export const getSearchSuggestions200ResponseDataSuggestionsItemMetadataSectionIdMax = 50;

export const getSearchSuggestions200ResponseDataSuggestionsItemMetadataSourceMax = 50;

export const getSearchSuggestions200ResponseDataSuggestionsItemSectionIdMax = 50;

export const GetSearchSuggestions200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                suggestions: zod
                    .array(
                        zod
                            .object({
                                suggest_id: zod.number().optional().describe("Unique identifier for the suggestion"),
                                value: zod
                                    .string()
                                    .max(getSearchSuggestions200ResponseDataSuggestionsItemValueMax)
                                    .optional()
                                    .describe("The suggested search term or phrase"),
                                text: zod
                                    .string()
                                    .max(getSearchSuggestions200ResponseDataSuggestionsItemTextMax)
                                    .optional()
                                    .describe("Display text with highlighting"),
                                type: zod
                                    .enum(["category", "brand", "product", "keyword", "post_title", "user", "hashtag"])
                                    .optional()
                                    .describe("Type of search suggestion"),
                                output_field: zod
                                    .string()
                                    .max(getSearchSuggestions200ResponseDataSuggestionsItemOutputFieldMax)
                                    .optional()
                                    .describe(
                                        "Field name for output (e.g., category_id, brand_id, or null for direct value)",
                                    ),
                                output_value: zod
                                    .number()
                                    .optional()
                                    .describe(
                                        "Output value - ID code for entities with IDs, or input value for others",
                                    ),
                                score: zod.number().optional().describe("Calculated relevance score (0-1000)"),
                                frequency_score: zod.number().optional().describe("Search frequency score (0-500)"),
                                recency_score: zod.number().optional().describe("Search recency score (0-300)"),
                                match_score: zod.number().optional().describe("Text match score (0-200)"),
                                metadata: zod
                                    .object({
                                        source_id: zod.string().optional().describe("ID of the source item"),
                                        section_id: zod
                                            .string()
                                            .max(getSearchSuggestions200ResponseDataSuggestionsItemMetadataSectionIdMax)
                                            .optional()
                                            .describe("Associated section ID"),
                                        image_url: zod.string().optional().describe("Product\/brand image URL"),
                                        general_description: zod
                                            .string()
                                            .optional()
                                            .describe("Additional description text"),
                                        source: zod
                                            .string()
                                            .max(getSearchSuggestions200ResponseDataSuggestionsItemMetadataSourceMax)
                                            .optional()
                                            .describe("Origin of this suggestion row (e.g. search_history)"),
                                        search_count: zod
                                            .number()
                                            .optional()
                                            .describe("Number of times this term has been searched"),
                                        last_searched_at: zod
                                            .string()
                                            .datetime({ offset: true })
                                            .optional()
                                            .describe("When this term was last searched"),
                                    })
                                    .strict()
                                    .optional()
                                    .describe("Additional context data"),
                                section_id: zod
                                    .string()
                                    .max(getSearchSuggestions200ResponseDataSuggestionsItemSectionIdMax)
                                    .optional()
                                    .describe("Section where suggestion originated (optional)"),
                                post_id: zod
                                    .number()
                                    .nullish()
                                    .describe("Related post ID (for title suggestions); null otherwise"),
                                user_id: zod.number().optional().describe("Related user ID (for user suggestions)"),
                            })
                            .strict(),
                    )
                    .optional(),
                total_count: zod.number().optional().describe("Total number of suggestions found"),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GetSearchSuggestions400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(422)]).describe("HTTP status code"),
    })
    .strict();

export const GetSearchSuggestions422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(422)]).describe("HTTP status code"),
    })
    .strict();

/**
 * Record a search query in user's history
 * @summary Save search history
 */
export const saveSearchHistoryBodyQueryMax = 100;

export const SaveSearchHistoryBody = zod
    .object({
        query: zod.string().max(saveSearchHistoryBodyQueryMax).describe("Search query"),
        search_type: zod
            .enum(["category", "brand", "product", "keyword", "post_title", "user", "hashtag"])
            .describe("Type of search suggestion"),
        section_id: zod
            .enum(["tech", "programming", "products", "frontend", "devops", "general"])
            .optional()
            .describe("Section identifier"),
    })
    .strict();

export const saveSearchHistory201ResponseDataQueryMax = 100;

export const saveSearchHistory201ResponseDataSectionIdMax = 50;

export const SaveSearchHistory201Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                user_id: zod.number().optional(),
                query: zod.string().max(saveSearchHistory201ResponseDataQueryMax).optional(),
                search_type: zod
                    .enum(["category", "brand", "product", "keyword", "post_title", "user", "hashtag"])
                    .optional()
                    .describe("Type of search suggestion"),
                section_id: zod.string().max(saveSearchHistory201ResponseDataSectionIdMax).optional(),
                saved: zod.boolean().optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const SaveSearchHistory400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(422)]).describe("HTTP status code"),
    })
    .strict();

export const SaveSearchHistory422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(422)]).describe("HTTP status code"),
    })
    .strict();

/**
 * Record hierarchical search queries (e.g., from breadcrumb navigation).
 * @summary Save hierarchical search history
 */
export const saveHierarchicalSearchHistoryBodyHierarchyItemQueryMax = 100;

export const SaveHierarchicalSearchHistoryBody = zod
    .object({
        hierarchy: zod
            .array(
                zod
                    .object({
                        query: zod
                            .string()
                            .max(saveHierarchicalSearchHistoryBodyHierarchyItemQueryMax)
                            .describe("Primary key value for the entity (e.g., category_id: '15', brand_id: '101')"),
                        search_type: zod
                            .enum(["category", "brand", "product", "keyword", "post_title", "user", "hashtag"])
                            .describe("Type of search suggestion"),
                        section_id: zod
                            .enum(["tech", "programming", "products", "frontend", "devops", "general"])
                            .optional()
                            .describe("Section identifier"),
                    })
                    .strict(),
            )
            .describe("Array of hierarchical search items (e.g., category -> brand)"),
    })
    .strict();

export const SaveHierarchicalSearchHistory201Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                saved_count: zod.number().optional().describe("Number of history items saved"),
                items: zod.array(zod.object({}).passthrough()).optional().describe("Array of saved history items"),
            })
            .strict()
            .optional(),
    })
    .strict();

export const SaveHierarchicalSearchHistory400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(422)]).describe("HTTP status code"),
    })
    .strict();

export const SaveHierarchicalSearchHistory422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(422)]).describe("HTTP status code"),
    })
    .strict();
